const AnswerUtils = {
    /**
     * Current published answer is `latestAnswer`, falling back to the last
     * `answerHistory` item (offline Dexie nodes / Answer History).
     * `EPAnswerData.answer` is a legacy stub and must not be used.
     */
    getCurrentAnswer(answer) {
        if (!answer) {
            return undefined;
        }
        const history = answer.data.answerHistory;
        const latest = answer.data.latestAnswer ?? history?.[history.length - 1];
        if (latest?.answer == null) {
            return undefined;
        }
        return {
            answer: latest.answer,
            ctime: latest.ctime ?? answer.utime,
        };
    },
    getAnswerHistoryCount(answer) {
        if (!answer) {
            return 0;
        }
        return answer.data.answerHistoryCount ?? answer.data.answerHistory?.length ?? 0;
    },
};
export default AnswerUtils;
